import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import type { ThunkAction, Action } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';

import { contactSlice } from '../features/contact/slice';
import { groupSlice } from '../features/group/slice';
import { whatsappSlice } from '../features/integration/slice/whatsaap.slice';

import { broadcastSlice } from '@/features/broadcast/slice/broadcast.slice';
import { catalogSlice } from '@/features/catalog-product/slice/index';
import { chatbotSlice } from '@/features/chatbot/slice/index';
import { chatSlice } from '@/features/liveChat/slice';
import { profileSlice } from '@/features/profiles/slice';
import { quickChatSlice } from '@/features/quickchat/slice';
import { timeworkSlice } from '@/features/timework/slice';
import { whatsappTemplateSlice } from '@/features/whatsappTemplate/slice/whatsapp-template.slice';
import { workspaceSlice } from '@/features/workspace/slice/workspace.slice';
import { filterSlice } from '@/slice/filter.slice';
import { notificationSlice } from '@/slice/notification.slice';
import { flowbuilderSlice } from '@/features/flowbuilder/dashboard/slice';
import flowSlice from '@/features/flowbuilder/reactflow/slice/flow.slice';
import previewChatSlice from '@/features/flowbuilder/reactflow/slice/preview-chat.slice';
import catalogProductSlice from '@/features/flowbuilder/reactflow/slice/catalog-product.slice';

const makeStore = () =>
  configureStore({
    middleware: getDefaultMiddleware({
      serializableCheck: false,
    }),
    reducer: {
      chat: chatSlice.reducer,
      whatsapp: whatsappSlice.reducer,
      notification: notificationSlice.reducer,
      whatsappTemplate: whatsappTemplateSlice.reducer,
      contact: contactSlice.reducer,
      broadcast: broadcastSlice.reducer,
      group: groupSlice.reducer,
      workspace: workspaceSlice.reducer,
      catalog: catalogSlice.reducer,
      chatbot: chatbotSlice.reducer,
      profile: profileSlice.reducer,
      filter: filterSlice.reducer,
      quickChat: quickChatSlice.reducer,
      timework: timeworkSlice.reducer,
      flow: flowSlice,
      flowbuilder: flowbuilderSlice.reducer,
      previewChat: previewChatSlice,
      catalogProduct: catalogProductSlice,
    },
    devTools: true,
  });

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action
>;

export const wrapper = createWrapper<AppStore>(makeStore);
